import { Grid } from "@mui/material";
import React from "react";

function CreatorCardOne() {
  const creatorData = [
    {
      id: "@jimena_stark",
      price: "4 sales on 14.28 ETH",
    },
    {
      id: "@@makinzi_beck",
      price: "16 sales on 8.04 ETH",
    },
    {
      id: "@@jaxon_duffy",
      price: "4 sales on 12.53 ETH",
    },
    {
      id: "@@darian_barry",
      price: "62 sales on 7.26 ETH",
    },
  ];
  return (
    <div className="card_top">
      <Grid
        container
        sx={{
          justifyContent: {
            xs: "center",
            sm: "center",
            md: "space-between",
            lg: "space-between",
          },
        }}
        className="margin_space"
      >
        {creatorData.map((e) => {
          return (
            <Grid
              item
              xs={12}
              sm={4}
              md={3.5}
              lg={2.9}
              className="creator_card_one"
            >
              <Grid container alignItems="center">
                <Grid item xs lg={4}>
                  <img src="./Assets/creator_1.png" alt="" />
                </Grid>
                <Grid item lg={8}>
                  <h5 className="id_sp">{e.id}</h5>
                  <p className="id_des_col">{e.price}</p>
                </Grid>
              </Grid>
            </Grid>
          );
        })}
      </Grid>
    </div>
  );
}

export default CreatorCardOne;
